import { BasicSelect } from 'vue-search-select';
import Matrix from './../../../../../shared/components/matrix';
import MasterService from './../../../../services/masterdata.service';
import CONSTANT from './../../../../../shared/constants/constant';
import VueElementLoading from 'vue-element-loading';
import CryptoJS from 'crypto-js';
import { Validator } from 'vee-validate';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
	name: 'Accessorial-Charges',
	components: {
		BasicSelect,
		Matrix,
		VueElementLoading,
		Treeselect
	},
	props: ['callFrom','ratebasis'],
	data() {
		return {
			expandType:"radio",
			isSaved:false,
			accessorialTab:"accessorialTab",
			odatab:"odatab",
			pickupodatab:"pickupodatab",
			//for wayBillCharges Accordian
			rateTemplateId: null,
			wayBillCharges: null,
			// FOD/ To Pay Charges
			chargePayType: null,
			payChargesInr: null,
			payChargePerc: null,
			fodCharges: null,
			minFodCharge: null,
			maxFodCharge: null,
			showdocket: false,
			showpercent: false,
			// Fuel Surcharge
			surchargePercentage: null,
			dieselRate: null,
			dieselhiketype: "%",
			surchargeFuelUpRevisionPercent: 0,
			surchargeFuelUpRevisionCharge: 0,
			surchargeFuelDownRevisionPercent: 0,
			surchargeFuelDownRevisionCharge: 0,
			dieselreflocation: null,
			// Delivery Attempts
			deliveryAttempt: null,
			costPerDeliveryAttempt: null,
			// Demurrage Charges
			freeStorageDays: null,
			demurrageCost: null,
			demurrageslotsdays: null,
			// Appointment/Different Vehicle Delivery
			isAppointmentLoading: false,
			slablist: [],
			slablistforOWC: [],
			slablistforODA: [],
			slablistforVehicleDelivery:[],
			locationlistforDieselPrice:[],
			allSlabDetails: [],
			selectedslab: {
				label: null,
				id: null
			},
			slabid: null,
			slabBreakupData: [],
			SYMBOL_CONFIG: {
				[CONSTANT.SLAB_SYMBOL_CONFIG.LESS_THAN_EQUAL_TO]: "<=",
				[CONSTANT.SLAB_SYMBOL_CONFIG.GREATER_THAN_EQUAL_TO]: ">=",
				[CONSTANT.SLAB_SYMBOL_CONFIG.LESS_THAN]: "<",
				[CONSTANT.SLAB_SYMBOL_CONFIG.GREATER_THAN]: ">"
			},
			costValue: [],
			// Handling Charges
			handlingChargePhysicalWeight: null,
			handlingLength: null,
			handlingBreadth: null,
			handlingHeight: null,
			rateType: 'FLAT',
			overweightcharges: null,
			mathadichargesperbox: null,
			isHandlingLoading: false,
			selectedhandlingslab: {
				label: null,
				id: null
			},
			handlingslabid: null,
			handlingslabBreakupData: [],
			handlingcostValue: [],
			// Delivery Above Ground Level
			MaxLevelAboveGroundCharges: null,
			AboveMaxLevelDefinedPerKg: null,
			AboveMaxLevelDefinedPerBox: null,
			// Green Tax
			docketCost: null,
			docketCostPerDocket: null,
			// RTO Charges
			rtoChargeType: null,
			rtoChargeList: [],
			selectedrtocharge: {
				label: null,
				id: null
			},
			rtocharge: null,
			//ODA Charges
			oda1ChargeList: [],
			oda2ChargeList: [],
			selectedOdaCharge1: {
				label: null,
				id: null
			},
			selectedOdaCharge2: {
				label: null,
				id: null
			},
			maxLimit: '',
			isLoading: false,
			SYMBOL_CONFIG: {
				[CONSTANT.SLAB_SYMBOL_CONFIG.LESS_THAN_EQUAL_TO]: "<=",
				[CONSTANT.SLAB_SYMBOL_CONFIG.GREATER_THAN_EQUAL_TO]: ">=",
				[CONSTANT.SLAB_SYMBOL_CONFIG.LESS_THAN]: "<",
				[CONSTANT.SLAB_SYMBOL_CONFIG.GREATER_THAN]: ">"
			},
			odaTemplateId1: null,
			odaTemplateId2: null,
			minMaxError: '',
			expanded:false,
			accordianTab:{1:false, 2:false, 3:false, 4:false, 5:false, 6:false,
											7:false, 8:false, 9:false, 10:false, 11:false, 12:false, 13:false, 14:false, 15:false},
			odaAccoordian:{1:false, 2:false, 3:false, 4:false},
			pickupodaAccoordian:{1:false, 2:false, 3:false, 4:false},
			vehicledeliverychargetype:null,
			vehicledeliveryperkgcost:null,
			vehicledeliveryminimumchargeperdocket:null,
			deliveryattemptmincharge:null,
			delievryabovegroundlevelapplicable:null,
			vehicledeliveryapplicable:null,
			demurragechargesapplicable:null,
			demurrageminimumcharges:null,
			mathadichargesperbox:null,
			greentaxminlimit:null,
			greentaxmaxlimit:null,
			handlingchargesapplicable:null,
			additionalRTOcharge:null,
			openpickdeliverycharges:null,
			openpickdeliveryrateperitem:null,
			openpickdeliverychargesminimum:null,
			openpickdeliveryapplicable:null,
			openpickupdelivery:null,
			holidaydeliverycharges:null,
			holidaydeliverymincharges:null,
			dccharges:null,
			mechanicalhandlingcharges:null,
			deliveryattempttype:null,
			demurragecostperdaytype:null,
			delievryabovegroundlevelchargetype:null,
			holidaydeliverychargeapplicable:null,
			holidaydeliverychargestype:null,
			vehicledeliveryratebasis:null,
			vehicledeliveryslabtype:null,
			vehicledeliveryslabchargetype:null,

			odachargesapplicable:null,
			isodadeliverychargesidenticaltopickup:null,
			odacharges:null,
			odachargesminimum:null,
			odachargetype:null,
			odachargeratebasis:null,
			odachargeslabchargetype:null,
			odachargeslabtype:null,
			selectedodaslab1 :null,
			odaslabid1 :null,
			odaslabbreakupdata1 : [],
			odacostvalue1 : [],
			odacostvalue12 : [],
			selectedodaslab2 :null,
			odaslabid2 :null,
			odaslabbreakupdata2 : [],
			odacostvalue2 : [],
			odacostvalue22 : [],
			selectedodaslab3 :null,
			odaslabid3 :null,
			odaslabbreakupdata3 : [],
			odacostvalue3 : [],
			odacostvalue32 : [],
			selectedodaslab4 :null,
			odaslabid4 :null,
			odaslabbreakupdata4 : [],
			odacostvalue4 : [],
			odacostvalue42 : [],
			oda1error: false,

			pickupodachargesapplicable:null,
			pickupodacharges:null,
			pickupodachargesminimum:null,
			pickupodachargetype:null,
			pickupodachargeratebasis:null,
			pickupodachargeslabchargetype:null,
			pickupodachargeslabtype:null,
			pickupselectedodaslab1 :null,
			pickupodaslabid1 :null,
			pickupodaslabbreakupdata1 : [],
			pickupodacostvalue1 : [],
			pickupodacostvalue12 : [],
			pickupselectedodaslab2 :null,
			pickupodaslabid2 :null,
			pickupodaslabbreakupdata2 : [],
			pickupodacostvalue2 : [],
			pickupodacostvalue22 : [],
			pickupselectedodaslab3 :null,
			pickupodaslabid3 :null,
			pickupodaslabbreakupdata3 : [],
			pickupodacostvalue3 : [],
			pickupodacostvalue32 : [],
			pickupselectedodaslab4 :null,
			pickupodaslabid4 :null,
			pickupodaslabbreakupdata4 : [],
			pickupodacostvalue4 : [],
			pickupodacostvalue42 : [],
			pickupoda1error: false,
			pickupslablistforODA: [],

			floorOptions:[
				{id:0,label:'Ground'},
				{id:1,label: 1},
				{id:2,label: 2},
				{id:3,label: 3},
				{id:4,label: 4},
				{id:5,label: 5},
				{id:6,label: 6},
				{id:7,label: 7},
				{id:8,label: 8},
				{id:9,label: 9},
				{id:10,label: 10},
			]
		}
	},
	computed: {},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.userName = userdetail.email;
		this.getSlabList();
	},
	methods: {
		isNumber: function(evt) {
			evt = (evt) ? evt : window.event;
			var charCode = (evt.which) ? evt.which : evt.keyCode;
			if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
			  evt.preventDefault();;
			} else {
			  return true;
			}
		},
		isIntegerOnlty: function(evt) {
				evt = (evt) ? evt : window.event;
				var charCode = (evt.which) ? evt.which : evt.keyCode;
				if (charCode < 48 || charCode > 57) {
				  evt.preventDefault();;
				} else {
				  return true;
				}
		},
		expandAll(){
			this.expanded = true;
			for (var key in this.accordianTab) {
				this.accordianTab[key] = true;
			}
		},
		collapseAll(){
			this.expanded = false;
			for (var key in this.accordianTab) {
				this.accordianTab[key] = false;
			}
		},
		toggleCheck(tabid){
			this.expanded = false;
			for (var key in this.accordianTab) {
				if(tabid != key){
					this.accordianTab[key] = false;
				}
			}
		},
		odaToggle(tabid){
		},
		pickupodaToggle(tabid){
		},
		checkMinMax() {
			this.$validator.validateAll()
			if (Number(this.maxFodCharge) < Number(this.minFodCharge)) {
				this.minMaxError = 'MinFodCharge cannot be greater than MaxFodCharge'
			} else {
				this.minMaxError = ''
			}
		},
		expandOrCollapseAllTab(type){
			if(type == 'expand'){
				this.expandType = "checkbox";
			} else if(type == 'collapse') {
				this.expandType = "collapse";
			}
		},
		getWithoutDecimalValue(str) {
			let convertedChargeValue = str.toString().split(".");
			convertedChargeValue = convertedChargeValue[1] == "00" ? convertedChargeValue[0] : el.charges;
			return convertedChargeValue
		},
		groupBy(array, property) {
			var hash = {};
			for (var i = 0; i < array.length; i++) {
				if (!hash[array[i][property]]) hash[array[i][property]] = [];
				hash[array[i][property]].push(array[i]);
			}
			return hash;
		},
		async checkIfOdaTemplateIsExist(rateTemplateId, isMasterRate) {
			try {
				let payload = {
					ratetemplateid: rateTemplateId
				}
				let odaTemplateDetails;
				if (!this.isSaved && (!this.callFrom || isMasterRate)) {
					odaTemplateDetails = await MasterService.getOdaChargeListRateTemplate(payload);
				} else if (this.callFrom && this.callFrom.name == CONSTANT.CONTRACT_TEMPLATE) {
					payload.ratetemplateid = this.callFrom.id
					odaTemplateDetails = await MasterService.getContractMasterOdaChargeList(payload);
				} else if (this.callFrom && this.callFrom.name == CONSTANT.CLIENT_CONTRACT_TEMPLATE) {
					payload.ratetemplateid = this.callFrom.id
					odaTemplateDetails = await MasterService.getClientContractMasterOdaChargeList(payload);
				}
				this.slablistforODA = [];
				let slabListGroup = this.groupBy(this.allSlabDetails, "slabtype");
				if(this.odachargeslabtype == 1 || this.pickupodachargeslabtype == 1){
					slabListGroup['1'].forEach(element => {
						let isdisabled = false;
						if(element.status==0){
							isdisabled = true;
						}
						this.slablistforODA.push({
							id: element.id,
							label: element.slabname,
							isDisabled:isdisabled
						});
					});
				}
				if(this.odachargeslabtype == 2 || this.pickupodachargeslabtype == 2){
					slabListGroup['4'].forEach(element => {
						let isdisabled = false;
						if(element.status==0){
							isdisabled = true;
						}
						this.slablistforODA.push({
							id: element.id,
							label: element.slabname,
							isDisabled:isdisabled
						});
					});
				}
				let splitArrayODAType = this.groupBy(odaTemplateDetails.data.data, "odatype");
				if(splitArrayODAType && splitArrayODAType.Delivery){
					let splitArray = this.groupBy(splitArrayODAType.Delivery, "templatesequence")
					if(splitArray['1']){
						if(this.odachargetype=="FlatRate"){
							this.odacostvalue1.push(splitArray['1'][0].charges)
							this.odacostvalue12.push(splitArray['1'][0].chargesperdocket)
						}
						if(this.odachargetype=="SlabRate"){
							this.odacostvalue1 = []
							this.odacostvalue11 = []
							this.odaslabbreakupdata1 = []
							this.odaslabid1 = splitArray['1'][0].slabid;
							this.selectedodaslab1 = this.getSlabObj(this.odaslabid1);
							splitArray['1'].forEach((item, i) => {
								let name = `${this.SYMBOL_CONFIG[item.lowerlimit]} ${item.lowerlimitvalue} to
											${this.SYMBOL_CONFIG[item.higherlimit]} ${item.higherlimitvalue}`
								this.odaslabbreakupdata1.push({
									slabsequence: item.slabsequence,
									name: name,
									lowerlimit:item.lowerlimit,
									lowerlimitvalue:item.lowerlimitvalue,
									higherlimit:item.higherlimit,
									higherlimitvalue:item.higherlimitvalue,
								})
								this.odacostvalue1[i] = item.charges
								this.odacostvalue11[i] = item.chargesperdocket
							});
						}
					}
					if(splitArray['2']){
						if(this.odachargetype=="FlatRate"){
							this.odacostvalue2.push(splitArray['2'][0].charges)
							this.odacostvalue22.push(splitArray['2'][0].chargesperdocket)
							}
						if(this.odachargetype=="SlabRate"){
							this.odacostvalue2 = []
							this.odacostvalue22 = []
							this.odaslabbreakupdata2 = []
							this.odaslabid2 = splitArray['2'][0].slabid;
							this.selectedodaslab2 = this.getSlabObj(this.odaslabid2);
							splitArray['2'].forEach((item, i) => {
								let name = `${this.SYMBOL_CONFIG[item.lowerlimit]} ${item.lowerlimitvalue} to
											${this.SYMBOL_CONFIG[item.higherlimit]} ${item.higherlimitvalue}`
								this.odaslabbreakupdata2.push({
									slabsequence: item.slabsequence,
									name: name,
									lowerlimit:item.lowerlimit,
									lowerlimitvalue:item.lowerlimitvalue,
									higherlimit:item.higherlimit,
									higherlimitvalue:item.higherlimitvalue,
								})
								this.odacostvalue2[i] = item.charges
								this.odacostvalue22[i] = item.chargesperdocket
							});
						}
					}
					if(splitArray['3']){
						if(this.odachargetype=="FlatRate"){
							this.odacostvalue3.push(splitArray['3'][0].charges)
							this.odacostvalue32.push(splitArray['3'][0].chargesperdocket)
						}
						if(this.odachargetype=="SlabRate"){
							this.odacostvalue3 = []
							this.odacostvalue32 = []
							this.odaslabbreakupdata3 = []
							this.odaslabid3 = splitArray['3'][0].slabid;
							this.selectedodaslab3 = this.getSlabObj(this.odaslabid3);
							splitArray['3'].forEach((item, i) => {
								let name = `${this.SYMBOL_CONFIG[item.lowerlimit]} ${item.lowerlimitvalue} to
											${this.SYMBOL_CONFIG[item.higherlimit]} ${item.higherlimitvalue}`
								this.odaslabbreakupdata3.push({
									slabsequence: item.slabsequence,
									name: name,
									lowerlimit:item.lowerlimit,
									lowerlimitvalue:item.lowerlimitvalue,
									higherlimit:item.higherlimit,
									higherlimitvalue:item.higherlimitvalue,
								})
								this.odacostvalue3[i] = item.charges
								this.odacostvalue32[i] = item.chargesperdocket
							});
						}
					}
					if(splitArray['4']){
						if(this.odachargetype=="FlatRate"){
							this.odacostvalue4.push(splitArray['4'][0].charges)
							this.odacostvalue42.push(splitArray['4'][0].chargesperdocket)
						}
						if(this.odachargetype=="SlabRate"){
							this.odacostvalue4 = []
							this.odacostvalue42 = []
							this.odaslabbreakupdata4 = []
							this.odaslabid4 = splitArray['1'][0].slabid;
							this.selectedodaslab4 = this.getSlabObj(this.odaslabid4);
							splitArray['4'].forEach((item, i) => {
								let name = `${this.SYMBOL_CONFIG[item.lowerlimit]} ${item.lowerlimitvalue} to
											${this.SYMBOL_CONFIG[item.higherlimit]} ${item.higherlimitvalue}`
								this.odaslabbreakupdata4.push({
									slabsequence: item.slabsequence,
									name: name,
									lowerlimit:item.lowerlimit,
									lowerlimitvalue:item.lowerlimitvalue,
									higherlimit:item.higherlimit,
									higherlimitvalue:item.higherlimitvalue,
								})
								this.odacostvalue4[i] = item.charges
								this.odacostvalue42[i] = item.chargesperdocket
							});
						}
					}
				}
				if(splitArrayODAType && splitArrayODAType.Pickup){
					let splitArray = this.groupBy(splitArrayODAType.Pickup, "templatesequence")
					if(splitArray['1']){
						if(this.pickupodachargetype=="FlatRate"){
							this.pickupodacostvalue1.push(splitArray['1'][0].charges)
							this.pickupodacostvalue12.push(splitArray['1'][0].chargesperdocket)
						}
						if(this.pickupodachargetype=="SlabRate"){
							this.pickupodacostvalue1 = []
							this.pickupodacostvalue11 = []
							this.pickupodaslabbreakupdata1 = []
							this.pickupodaslabid1 = splitArray['1'][0].slabid;
							this.pickupselectedodaslab1 = this.getSlabObj(this.pickupodaslabid1);
							splitArray['1'].forEach((item, i) => {
								let name = `${this.SYMBOL_CONFIG[item.lowerlimit]} ${item.lowerlimitvalue} to
											${this.SYMBOL_CONFIG[item.higherlimit]} ${item.higherlimitvalue}`
								this.pickupodaslabbreakupdata1.push({
									slabsequence: item.slabsequence,
									name: name,
									lowerlimit:item.lowerlimit,
									lowerlimitvalue:item.lowerlimitvalue,
									higherlimit:item.higherlimit,
									higherlimitvalue:item.higherlimitvalue,
								})
								this.pickupodacostvalue1[i] = item.charges
								this.pickupodacostvalue11[i] = item.chargesperdocket
							});
						}
					}
					if(splitArray['2']){
						if(this.pickupodachargetype=="FlatRate"){
							this.pickupodacostvalue2.push(splitArray['2'][0].charges)
							this.pickupodacostvalue22.push(splitArray['2'][0].chargesperdocket)
							}
						if(this.pickupodachargetype=="SlabRate"){
							this.pickupodacostvalue2 = []
							this.pickupodacostvalue22 = []
							this.pickupodaslabbreakupdata2 = []
							this.pickupodaslabid2 = splitArray['2'][0].slabid;
							this.pickupselectedodaslab2 = this.getSlabObj(this.pickupodaslabid2);
							splitArray['2'].forEach((item, i) => {
								let name = `${this.SYMBOL_CONFIG[item.lowerlimit]} ${item.lowerlimitvalue} to
											${this.SYMBOL_CONFIG[item.higherlimit]} ${item.higherlimitvalue}`
								this.pickupodaslabbreakupdata2.push({
									slabsequence: item.slabsequence,
									name: name,
									lowerlimit:item.lowerlimit,
									lowerlimitvalue:item.lowerlimitvalue,
									higherlimit:item.higherlimit,
									higherlimitvalue:item.higherlimitvalue,
								})
								this.pickupodacostvalue2[i] = item.charges
								this.pickupodacostvalue22[i] = item.chargesperdocket
							});
						}
					}
					if(splitArray['3']){
						if(this.pickupodachargetype=="FlatRate"){
							this.pickupodacostvalue3.push(splitArray['3'][0].charges)
							this.pickupodacostvalue32.push(splitArray['3'][0].chargesperdocket)
						}
						if(this.pickupodachargetype=="SlabRate"){
							this.pickupodacostvalue3 = []
							this.pickupodacostvalue32 = []
							this.pickupodaslabbreakupdata3 = []
							this.pickupodaslabid3 = splitArray['3'][0].slabid;
							this.pickupselectedodaslab3 = this.getSlabObj(this.pickupodaslabid3);
							splitArray['3'].forEach((item, i) => {
								let name = `${this.SYMBOL_CONFIG[item.lowerlimit]} ${item.lowerlimitvalue} to
											${this.SYMBOL_CONFIG[item.higherlimit]} ${item.higherlimitvalue}`
								this.pickupodaslabbreakupdata3.push({
									slabsequence: item.slabsequence,
									name: name,
									lowerlimit:item.lowerlimit,
									lowerlimitvalue:item.lowerlimitvalue,
									higherlimit:item.higherlimit,
									higherlimitvalue:item.higherlimitvalue,
								})
								this.pickupodacostvalue3[i] = item.charges
								this.pickupodacostvalue32[i] = item.chargesperdocket
							});
						}
					}
					if(splitArray['4']){
						if(this.pickupodachargetype=="FlatRate"){
							this.pickupodacostvalue4.push(splitArray['4'][0].charges)
							this.pickupodacostvalue42.push(splitArray['4'][0].chargesperdocket)
						}
						if(this.pickupodachargetype=="SlabRate"){
							this.pickupodacostvalue4 = []
							this.pickupodacostvalue42 = []
							this.pickupodaslabbreakupdata4 = []
							this.pickupodaslabid4 = splitArray['1'][0].slabid;
							this.pickupselectedodaslab4 = this.getSlabObj(this.odaslabid4);
							splitArray['4'].forEach((item, i) => {
								let name = `${this.SYMBOL_CONFIG[item.lowerlimit]} ${item.lowerlimitvalue} to
											${this.SYMBOL_CONFIG[item.higherlimit]} ${item.higherlimitvalue}`
								this.pickupodaslabbreakupdata4.push({
									slabsequence: item.slabsequence,
									name: name,
									lowerlimit:item.lowerlimit,
									lowerlimitvalue:item.lowerlimitvalue,
									higherlimit:item.higherlimit,
									higherlimitvalue:item.higherlimitvalue,
								})
								this.pickupodacostvalue4[i] = item.charges
								this.pickupodacostvalue42[i] = item.chargesperdocket
							});
						}
					}
				}
			} catch (err) {
				this.isLoading = false;
				console.log(err);
			}
		},

		async saveBothOdaTemplateData() {
			try {
				this.oda1error = false;
				this.pickupoda1error = false;
				var inputPayload = {
						lastmodifiedby: this.userName,
						createdby: this.userName,
						ratetemplateid: this.rateTemplateId,
						odachargesapplicable: (this.odachargesapplicable=="Yes")?1:0,
						pickupodachargesapplicable: (this.pickupodachargesapplicable=="Yes")?1:0,
				};

				let odaChargetype = null
				if(this.odachargetype=="FlatRate"){
					odaChargetype = 1
				}else if(this.odachargetype=="SlabRate"){
					odaChargetype = 2
				}
				inputPayload.odachargetype = odaChargetype;

				if (this.odachargetype=="SlabRate" && this.odaslabid1 != "" && this.odaslabid1 != null) {
					let odaslabarray1 = [];
					for (var i = 0; i < this.odaslabbreakupdata1.length; i++) {
						odaslabarray1.push({
							slabid: this.odaslabid1,
							slabsequence: this.odaslabbreakupdata1[i].slabsequence,
							templatesequence: 1,
							lowerlimit:this.odaslabbreakupdata1[i].lowerlimit,
							lowerlimitvalue:this.odaslabbreakupdata1[i].lowerlimitvalue,
							higherlimit:this.odaslabbreakupdata1[i].higherlimit,
							higherlimitvalue:this.odaslabbreakupdata1[i].higherlimitvalue,
							cost: this.odacostvalue1[i] || null,
							costperdocket: this.odacostvalue12[i] || null,
						});
					}
					let odaslabarray2 = [];
					for (var i = 0; i < this.odaslabbreakupdata2.length; i++) {
						odaslabarray2.push({
							slabid: this.odaslabid2,
							slabsequence: this.odaslabbreakupdata2[i].slabsequence,
							templatesequence: 2,
							lowerlimit:this.odaslabbreakupdata2[i].lowerlimit,
							lowerlimitvalue:this.odaslabbreakupdata2[i].lowerlimitvalue,
							higherlimit:this.odaslabbreakupdata2[i].higherlimit,
							higherlimitvalue:this.odaslabbreakupdata2[i].higherlimitvalue,
							cost: this.odacostvalue2[i] || null,
							costperdocket: this.odacostvalue22[i] || null,
						});
					}
					let odaslabarray3 = [];
					for (var i = 0; i < this.odaslabbreakupdata3.length; i++) {
						odaslabarray3.push({
							slabid: this.odaslabid3,
							slabsequence: this.odaslabbreakupdata3[i].slabsequence,
							templatesequence: 3,
							lowerlimit:this.odaslabbreakupdata3[i].lowerlimit,
							lowerlimitvalue:this.odaslabbreakupdata3[i].lowerlimitvalue,
							higherlimit:this.odaslabbreakupdata3[i].higherlimit,
							higherlimitvalue:this.odaslabbreakupdata3[i].higherlimitvalue,
							cost: this.odacostvalue3[i] || null,
							costperdocket: this.odacostvalue32[i] || null,
						});
					}
					let odaslabarray4 = [];
					for (var i = 0; i < this.odaslabbreakupdata4.length; i++) {
						odaslabarray4.push({
							slabid: this.odaslabid4,
							slabsequence: this.odaslabbreakupdata4[i].slabsequence,
							templatesequence: 4,
							lowerlimit:this.odaslabbreakupdata4[i].lowerlimit,
							lowerlimitvalue:this.odaslabbreakupdata4[i].lowerlimitvalue,
							higherlimit:this.odaslabbreakupdata4[i].higherlimit,
							higherlimitvalue:this.odaslabbreakupdata4[i].higherlimitvalue,
							cost: this.odacostvalue4[i]  || null,
							costperdocket: this.odacostvalue42[i]  || null,
						});
					}
					inputPayload.odaChargeArray = [...odaslabarray1, ...odaslabarray2,...odaslabarray3, ...odaslabarray4]
				}else if(this.odachargetype=="FlatRate"){
					let odaslabarray1 = [];
						odaslabarray1.push({
							templatesequence: 1,
							cost: this.odacostvalue1[0] || null,
							costperdocket: this.odacostvalue12[0] || null,
						});
					let odaslabarray2 = [];
						odaslabarray2.push({
							templatesequence: 2,
							cost: this.odacostvalue2[0] || null,
							costperdocket: this.odacostvalue22[0] || null,
						});
					let odaslabarray3 = [];
						odaslabarray3.push({
							templatesequence: 3,
							cost: this.odacostvalue3[0] || null,
							costperdocket: this.odacostvalue32[0] || null,
						});
					let odaslabarray4 = [];
						odaslabarray4.push({
							templatesequence: 4,
							cost: this.odacostvalue4[0] || null,
							costperdocket: this.odacostvalue42[0] || null,
						});
					inputPayload.odaChargeArray = [...odaslabarray1, ...odaslabarray2,...odaslabarray3, ...odaslabarray4];
				}else{
					inputPayload.odaChargeArray = [];
				}
				if (this.odachargetype=="SlabRate") {
					if (this.odachargesapplicable == "Yes") {
						if (inputPayload.odaChargeArray.length == 0 ) {
							this.oda1error = true;
							return false;
						}
						for (var i = 0; i < inputPayload.odaChargeArray.length; i++) {
							if(inputPayload.odaChargeArray[i].templatesequence == 1 && inputPayload.odaChargeArray[i].cost == null){
								this.oda1error = true;
								return false;
							}
						}
					}
				}else{
					if (this.odachargesapplicable == "Yes" && (inputPayload.odaChargeArray.length == 0 || inputPayload.odaChargeArray[0].cost == null)) {
						this.oda1error = true;
						return false;
					}
				}

				let pickupodaChargetype = null
				if(this.pickupodachargetype=="FlatRate"){
					pickupodaChargetype = 1
				}else if(this.pickupodachargetype=="SlabRate"){
					pickupodaChargetype = 2
				}
				inputPayload.pickupodachargetype = pickupodaChargetype;

				if (this.pickupodachargetype=="SlabRate" && this.pickupodaslabid1 != "" && this.pickupodaslabid1 != null) {
					let pickupodaslabarray1 = [];
					for (var i = 0; i < this.pickupodaslabbreakupdata1.length; i++) {
						pickupodaslabarray1.push({
							slabid: this.pickupodaslabid1,
							slabsequence: this.pickupodaslabbreakupdata1[i].slabsequence,
							templatesequence: 1,
							lowerlimit:this.pickupodaslabbreakupdata1[i].lowerlimit,
							lowerlimitvalue:this.pickupodaslabbreakupdata1[i].lowerlimitvalue,
							higherlimit:this.pickupodaslabbreakupdata1[i].higherlimit,
							higherlimitvalue:this.pickupodaslabbreakupdata1[i].higherlimitvalue,
							cost: this.pickupodacostvalue1[i] || null,
							costperdocket: this.pickupodacostvalue12[i] || null,
						});
					}
					let pickupodaslabarray2 = [];
					for (var i = 0; i < this.pickupodaslabbreakupdata2.length; i++) {
						pickupodaslabarray2.push({
							slabid: this.pickupodaslabid2,
							slabsequence: this.pickupodaslabbreakupdata2[i].slabsequence,
							templatesequence: 2,
							lowerlimit:this.pickupodaslabbreakupdata2[i].lowerlimit,
							lowerlimitvalue:this.pickupodaslabbreakupdata2[i].lowerlimitvalue,
							higherlimit:this.pickupodaslabbreakupdata2[i].higherlimit,
							higherlimitvalue:this.pickupodaslabbreakupdata2[i].higherlimitvalue,
							cost: this.pickupodacostvalue2[i] || null,
							costperdocket: this.pickupodacostvalue22[i] || null,
						});
					}
					let pickupodaslabarray3 = [];
					for (var i = 0; i < this.pickupodaslabbreakupdata3.length; i++) {
						pickupodaslabarray3.push({
							slabid: this.pickupodaslabid3,
							slabsequence: this.pickupodaslabbreakupdata3[i].slabsequence,
							templatesequence: 3,
							lowerlimit:this.pickupodaslabbreakupdata3[i].lowerlimit,
							lowerlimitvalue:this.pickupodaslabbreakupdata3[i].lowerlimitvalue,
							higherlimit:this.pickupodaslabbreakupdata3[i].higherlimit,
							higherlimitvalue:this.pickupodaslabbreakupdata3[i].higherlimitvalue,
							cost: this.pickupodacostvalue3[i] || null,
							costperdocket: this.pickupodacostvalue32[i] || null,
						});
					}
					let pickupodaslabarray4 = [];
					for (var i = 0; i < this.pickupodaslabbreakupdata4.length; i++) {
						pickupodaslabarray4.push({
							slabid: this.pickupodaslabid4,
							slabsequence: this.pickupodaslabbreakupdata4[i].slabsequence,
							templatesequence: 4,
							lowerlimit:this.pickupodaslabbreakupdata4[i].lowerlimit,
							lowerlimitvalue:this.pickupodaslabbreakupdata4[i].lowerlimitvalue,
							higherlimit:this.pickupodaslabbreakupdata4[i].higherlimit,
							higherlimitvalue:this.pickupodaslabbreakupdata4[i].higherlimitvalue,
							cost: this.pickupodacostvalue4[i]  || null,
							costperdocket: this.pickupodacostvalue42[i]  || null,
						});
					}
					inputPayload.pickupodaChargeArray = [...pickupodaslabarray1, ...pickupodaslabarray2,...pickupodaslabarray3, ...pickupodaslabarray4]
				}else if(this.pickupodachargetype=="FlatRate"){
					let pickupodaslabarray1 = [];
						pickupodaslabarray1.push({
							templatesequence: 1,
							cost: this.pickupodacostvalue1[0] || null,
							costperdocket: this.pickupodacostvalue12[0] || null,
						});
					let pickupodaslabarray2 = [];
						pickupodaslabarray2.push({
							templatesequence: 2,
							cost: this.pickupodacostvalue2[0] || null,
							costperdocket: this.pickupodacostvalue22[0] || null,
						});
					let pickupodaslabarray3 = [];
						pickupodaslabarray3.push({
							templatesequence: 3,
							cost: this.pickupodacostvalue3[0] || null,
							costperdocket: this.pickupodacostvalue32[0] || null,
						});
					let pickupodaslabarray4 = [];
						pickupodaslabarray4.push({
							templatesequence: 4,
							cost: this.pickupodacostvalue4[0] || null,
							costperdocket: this.pickupodacostvalue42[0] || null,
						});
					inputPayload.pickupodaChargeArray = [...pickupodaslabarray1, ...pickupodaslabarray2,...pickupodaslabarray3, ...pickupodaslabarray4];
				}else{
					inputPayload.pickupodaChargeArray = [];
				}
				if (this.pickupodachargetype=="SlabRate") {
					if (this.pickupodachargesapplicable == "Yes") {
						if (inputPayload.pickupodaChargeArray.length == 0 ) {
							this.pickupoda1error = true;
							return false;
						}
						for (var i = 0; i < inputPayload.pickupodaChargeArray.length; i++) {
							if(inputPayload.pickupodaChargeArray[i].templatesequence == 1 && inputPayload.pickupodaChargeArray[i].cost == null){
								this.pickupoda1error = true;
								return false;
							}
						}
					 }
					}else{
						if (this.pickupodachargesapplicable == "Yes" && (inputPayload.pickupodaChargeArray.length == 0 || inputPayload.pickupodaChargeArray[0].cost == null)) {
							this.pickupoda1error = true;
							return false;
						}
					}

					let result;
					let odaTemplateDetails;
					if (!this.callFrom) {
						result = await MasterService.saveOdaCharges(inputPayload);
					} else if (this.callFrom && this.callFrom.name == CONSTANT.CONTRACT_TEMPLATE) {
						inputPayload.ratetemplateid = this.callFrom.id
						inputPayload.contractid = this.callFrom.contractid
						inputPayload.contractservicesid = this.callFrom.contractservicesid
						result = await MasterService.saveContractMasterOdaCharges(inputPayload);
					} else if (this.callFrom && this.callFrom.name == CONSTANT.CLIENT_CONTRACT_TEMPLATE) {
						inputPayload.ratetemplateid = this.callFrom.id
						inputPayload.contractid = this.callFrom.contractid
						inputPayload.contractservicesid = this.callFrom.contractservicesid
						result = await MasterService.saveClientContractMasterOdaCharges(inputPayload);
					}

			} catch (err) {
				this.isLoading = false;
				console.log(err);
			}
		},
		async setValues(rateTemplateDetailsObject, isMasterRate) {
			await this.getLocationListDieselPrice();
			this.rateTemplateId = rateTemplateDetailsObject.id;
			if (rateTemplateDetailsObject && rateTemplateDetailsObject.id) {
				this.wayBillCharges = rateTemplateDetailsObject.waybillcharge;

				if (rateTemplateDetailsObject.fodchargetype == CONSTANT.ACCESSORIAL_CHARGE_PAY_TYPE.DOCKET) {
					this.chargePayType = 'DOCKET';
					this.showdocket = true
					this.showpercent = false
					this.payChargesInr = rateTemplateDetailsObject.fodcharges;
				} else if (rateTemplateDetailsObject.fodchargetype == CONSTANT.ACCESSORIAL_CHARGE_PAY_TYPE.PERCENT) {
					this.chargePayType = 'PERCENT';
					this.showdocket = false
					this.showpercent = true
					this.payChargePerc = rateTemplateDetailsObject.fodcharges;
				}
				this.fodCharges = rateTemplateDetailsObject.fodcharges;
				this.minFodCharge = rateTemplateDetailsObject.fodmincharge;
				this.maxFodCharge = rateTemplateDetailsObject.fodmaxcharge

				this.surchargePercentage = rateTemplateDetailsObject.fuelsurchargepercent
				this.dieselRate = rateTemplateDetailsObject.fueldieselrate

				if(rateTemplateDetailsObject.dieselreflocation){
					let obj = this.locationlistforDieselPrice.find(item => item.label == rateTemplateDetailsObject.dieselreflocation);
					this.dieselreflocation = obj;
				}

				this.dieselhiketype = (rateTemplateDetailsObject.dieselhiketype)?rateTemplateDetailsObject.dieselhiketype:'%'
				this.surchargeFuelUpRevisionPercent = rateTemplateDetailsObject.fueluprevision
				this.surchargeFuelUpRevisionCharge = rateTemplateDetailsObject.fueluprevisioncharge
				this.surchargeFuelDownRevisionPercent = rateTemplateDetailsObject.fueldownrevision
				this.surchargeFuelDownRevisionCharge = rateTemplateDetailsObject.fueldownrevisioncharge

				this.deliveryAttempt = rateTemplateDetailsObject.deliveryattempt
				this.costPerDeliveryAttempt = rateTemplateDetailsObject.costperdeliveryattempt

				this.freeStorageDays = rateTemplateDetailsObject.demurragefreestoragedays
				this.demurrageCost = rateTemplateDetailsObject.demurragecostperday
				this.demurrageslotsdays = rateTemplateDetailsObject.demurrageslotsdays

				this.mathadichargesperbox = rateTemplateDetailsObject.mathadichargesperbox

				this.handlingChargePhysicalWeight = rateTemplateDetailsObject.handlingchargephysicalwt
				this.handlingLength = rateTemplateDetailsObject.handlingchargedimesnion && rateTemplateDetailsObject.handlingchargedimesnion.handlinglength
				this.handlingBreadth = rateTemplateDetailsObject.handlingchargedimesnion && rateTemplateDetailsObject.handlingchargedimesnion.handlingbreadth
				this.handlingHeight = rateTemplateDetailsObject.handlingchargedimesnion && rateTemplateDetailsObject.handlingchargedimesnion.handlingHeight

				this.rateType = rateTemplateDetailsObject.handlingchargeoverwtchargetype && rateTemplateDetailsObject.handlingchargeoverwtchargetype == 2 ? 'SLAB' : 'FLAT';
				this.MaxLevelAboveGroundCharges = rateTemplateDetailsObject.delievryabovegroundlevelmax
				this.AboveMaxLevelDefinedPerKg = rateTemplateDetailsObject.delievryabovegroundlevelchargeperkg
				this.AboveMaxLevelDefinedPerBox = rateTemplateDetailsObject.delievryabovegroundlevelchargeperdocket
				this.docketCost = rateTemplateDetailsObject.greentaxperkg
				this.docketCostPerDocket = rateTemplateDetailsObject.greentaxperdocket
				this.rtoChargeType = rateTemplateDetailsObject.rtocharges && rateTemplateDetailsObject.rtocharges == 1 ? 'SAME_AS_FORWARD_CHARGES' : 'CHOOSE_FROM_A_RATE_LIST';

				if(rateTemplateDetailsObject.vehicledeliverychargetype==1){
					this.vehicledeliverychargetype="FlatRate"
				}else if(rateTemplateDetailsObject.vehicledeliverychargetype==2){
					this.vehicledeliverychargetype="SlabBased"
				}else if(rateTemplateDetailsObject.vehicledeliverychargetype==3){
					this.vehicledeliverychargetype="ApprovalBasis"
				}

				this.vehicledeliveryminimumchargeperdocket=rateTemplateDetailsObject.vehicledeliveryminimumchargeperdocket;
				this.deliveryattemptmincharge=rateTemplateDetailsObject.deliveryattemptmincharge;
				this.delievryabovegroundlevelapplicable=(rateTemplateDetailsObject.delievryabovegroundlevelapplicable==1)?"Yes":"No";
				this.vehicledeliveryapplicable=(rateTemplateDetailsObject.vehicledeliveryapplicable==1)?"Yes":"No";
				this.demurragechargesapplicable=(rateTemplateDetailsObject.demurragechargesapplicable==1)?"Yes":"No";
				this.demurrageminimumcharges=rateTemplateDetailsObject.demurrageminimumcharges;

				this.mathadichargesperbox=rateTemplateDetailsObject.mathadichargesperbox;

				this.greentaxminlimit=rateTemplateDetailsObject.greentaxminlimit;
				this.greentaxmaxlimit=rateTemplateDetailsObject.greentaxmaxlimit;
				this.handlingchargesapplicable=(rateTemplateDetailsObject.handlingchargesapplicable==1)?"Yes":"No";
				this.rtocharge=rateTemplateDetailsObject.rtocharges;
				this.odachargetype=(rateTemplateDetailsObject.odachargetype==1)?"FlatRate":(rateTemplateDetailsObject.odachargetype==2)?"SlabRate":null;
				this.pickupodachargetype=(rateTemplateDetailsObject.pickupodachargetype==1)?"FlatRate":(rateTemplateDetailsObject.pickupodachargetype==2)?"SlabRate":null;
				this.odachargesapplicable=(rateTemplateDetailsObject.odachargesapplicable==1)?"Yes":"No";
				this.isodadeliverychargesidenticaltopickup=(rateTemplateDetailsObject.isodadeliverychargesidenticaltopickup==1)?"Yes":"No";
				this.pickupodachargesapplicable=(rateTemplateDetailsObject.pickupodachargesapplicable==1)?"Yes":"No";
				this.odacharges=rateTemplateDetailsObject.odacharges;
				this.openpickdeliverycharges=rateTemplateDetailsObject.openpickdeliverycharges;
				if(rateTemplateDetailsObject.openpickdeliverycharges){
					this.openpickupdelivery = 1;
				}else{
					this.openpickupdelivery = 2;
				}
				this.openpickdeliveryrateperitem=rateTemplateDetailsObject.openpickdeliveryrateperitem;
				this.odachargesminimum=rateTemplateDetailsObject.odachargesminimum;
				this.pickupodachargesminimum=rateTemplateDetailsObject.pickupodachargesminimum;
				this.openpickdeliverychargesminimum=rateTemplateDetailsObject.openpickdeliverychargesminimum;
				this.openpickdeliveryapplicable=(rateTemplateDetailsObject.openpickdeliveryapplicable==1)?"Yes":"No";
				this.holidaydeliverycharges=rateTemplateDetailsObject.holidaydeliverycharges;
				this.holidaydeliverymincharges=rateTemplateDetailsObject.holidaydeliverymincharges;
				this.dccharges=rateTemplateDetailsObject.dccharges;
				this.mechanicalhandlingcharges=rateTemplateDetailsObject.mechanicalhandlingcharges;
				this.holidaydeliverychargeapplicable=(rateTemplateDetailsObject.holidaydeliverychargeapplicable==1)?"Yes":"No";
				this.deliveryattempttype = (rateTemplateDetailsObject.deliveryattempttype)?rateTemplateDetailsObject.deliveryattempttype:null;
				this.demurragecostperdaytype = (rateTemplateDetailsObject.demurragecostperdaytype)?rateTemplateDetailsObject.demurragecostperdaytype:null,
				this.delievryabovegroundlevelchargetype = (rateTemplateDetailsObject.delievryabovegroundlevelchargetype)?rateTemplateDetailsObject.delievryabovegroundlevelchargetype:null;
				this.holidaydeliverychargestype = (rateTemplateDetailsObject.holidaydeliverychargestype)?rateTemplateDetailsObject.holidaydeliverychargestype:null;
				this.vehicledeliveryratebasis = (rateTemplateDetailsObject.vehicledeliveryratebasis)?rateTemplateDetailsObject.vehicledeliveryratebasis:1;
				this.vehicledeliveryslabtype = (rateTemplateDetailsObject.vehicledeliveryslabtype)?rateTemplateDetailsObject.vehicledeliveryslabtype:null;
				this.vehicledeliveryslabchargetype = (rateTemplateDetailsObject.vehicledeliveryslabchargetype)?rateTemplateDetailsObject.vehicledeliveryslabchargetype:null;
				this.odachargeslabchargetype = (rateTemplateDetailsObject.odachargeslabchargetype)?rateTemplateDetailsObject.odachargeslabchargetype:null;
				this.pickupodachargeslabchargetype = (rateTemplateDetailsObject.pickupodachargeslabchargetype)?rateTemplateDetailsObject.pickupodachargeslabchargetype:null;
				this.odachargeslabtype = (rateTemplateDetailsObject.odachargeslabtype)?rateTemplateDetailsObject.odachargeslabtype:null;
				this.pickupodachargeslabtype = (rateTemplateDetailsObject.pickupodachargeslabtype)?rateTemplateDetailsObject.pickupodachargeslabtype:null;
				this.odachargeratebasis = (rateTemplateDetailsObject.odachargeratebasis)?rateTemplateDetailsObject.odachargeratebasis:null;
				this.pickupodachargeratebasis = (rateTemplateDetailsObject.pickupodachargeratebasis)?rateTemplateDetailsObject.pickupodachargeratebasis:null;

				this.getVehicleDeliveryDetails(isMasterRate);
				this.getOverWtChargeDetails(isMasterRate);
				this.checkIfOdaTemplateIsExist(this.rateTemplateId, isMasterRate)
			}
		},
		saveOnTabChange(){
			this.validateAndsaveAccessorialCharges("saveAndNext")
		},
		validateAndsaveAccessorialCharges(type) {
			this.$validator.validateAll().then((result) => {
				if (result) {
					this.saveAccessorialCharges(type);
				}else{
					this.expandAll();
				}
			}).catch((err) => {
				console.log('errors exist', err)
			});
		},
		async saveAccessorialCharges(type) {
			if(this.chargePayType) {
				this.showChargePayType()
			}
			var vehicledelchargetype = null
			if(this.vehicledeliverychargetype=="FlatRate"){
				vehicledelchargetype = 1
			}else if(this.vehicledeliverychargetype=="SlabBased"){
				vehicledelchargetype = 2
			}else if(this.vehicledeliverychargetype=="ApprovalBasis"){
				vehicledelchargetype = 3
			}
			let submitobject = {
				waybillcharge: this.wayBillCharges || null,

				fodchargetype: this.chargePayType && CONSTANT.ACCESSORIAL_CHARGE_PAY_TYPE[this.chargePayType],
				fodcharges: this.fodCharges || null,
				fodmincharge: this.minFodCharge || null,
				fodmaxcharge: this.maxFodCharge || null,

				fuelsurchargepercent:this.surchargePercentage || null,
				fueldieselrate: this.dieselRate || null,
				dieselreflocation: this.dieselreflocation.label || null,
				dieselhiketype: (this.dieselhiketype)?this.dieselhiketype:'%',
				fueluprevision: (this.surchargeFuelUpRevisionPercent)?this.surchargeFuelUpRevisionPercent:0,
				fueluprevisioncharge: (this.surchargeFuelUpRevisionCharge)?this.surchargeFuelUpRevisionCharge:0,
				fueldownrevision: (this.surchargeFuelDownRevisionPercent)?this.surchargeFuelDownRevisionPercent:0,
				fueldownrevisioncharge: (this.surchargeFuelDownRevisionCharge)?this.surchargeFuelDownRevisionCharge:0,

				deliveryattempt:this.deliveryAttempt || null,
				costperdeliveryattempt: this.costPerDeliveryAttempt || null,

				demurragefreestoragedays:this.freeStorageDays || null,
				demurragecostperday: this.demurrageCost || null,
				demurrageslotsdays: this.demurrageslotsdays || null,

				mathadichargesperbox: this.mathadichargesperbox || null,

				handlingchargephysicalwt:this.handlingChargePhysicalWeight || null,
				handlingchargedimesnion: {
					handlinglength: this.handlingLength || null,
					handlingbreadth: this.handlingBreadth || null,
					handlingHeight:  this.handlingHeight || null
				},
				handlingchargeoverwtchargetype: this.rateType && CONSTANT.ACCESSORIAL_RATE_TYPE[this.rateType],
				delievryabovegroundlevelmax:this.MaxLevelAboveGroundCharges,
				delievryabovegroundlevelchargeperkg: this.AboveMaxLevelDefinedPerKg || null,
				delievryabovegroundlevelchargeperdocket: this.AboveMaxLevelDefinedPerBox || null,

				greentaxperkg: this.docketCost || null,
				greentaxperdocket: this.docketCostPerDocket || null,

				rtocharges:this.rtocharge || null,
				vehicledeliverychargetype:vehicledelchargetype,
				vehicledeliveryminimumchargeperdocket: this.vehicledeliveryminimumchargeperdocket || null,
				deliveryattemptmincharge: this.deliveryattemptmincharge || null,
				delievryabovegroundlevelapplicable:(this.delievryabovegroundlevelapplicable=="Yes")?1:0,
				vehicledeliveryapplicable:(this.vehicledeliveryapplicable=="Yes")?1:0,
				demurragechargesapplicable:(this.demurragechargesapplicable=="Yes")?1:0,
				demurrageminimumcharges:this.demurrageminimumcharges || null,
				handlingchargesapplicable:(this.handlingchargesapplicable=="Yes")?1:0,

				odachargesapplicable:(this.odachargesapplicable=="Yes")?1:0,
				isodadeliverychargesidenticaltopickup:(this.isodadeliverychargesidenticaltopickup=="Yes")?1:0,
				odachargeratebasis:this.odachargeratebasis,
				odachargetype:(this.odachargetype=="FlatRate")?1:(this.odachargetype=="SlabRate")?2:null,
				odachargeslabtype:this.odachargeslabtype,
				odachargeslabchargetype:this.odachargeslabchargetype,
				odachargesminimum:this.odachargesminimum || null,
				odacharges: this.odacharges || null,
				pickupodachargesapplicable:(this.pickupodachargesapplicable=="Yes")?1:0,
				pickupodachargeratebasis:this.pickupodachargeratebasis,
				pickupodachargetype:(this.pickupodachargetype=="FlatRate")?1:(this.pickupodachargetype=="SlabRate")?2:null,
				pickupodachargeslabtype:this.pickupodachargeslabtype,
				pickupodachargeslabchargetype:this.pickupodachargeslabchargetype,
				pickupodachargesminimum:this.pickupodachargesminimum || null,

				openpickdeliverycharges:this.openpickdeliverycharges || null,
				openpickdeliveryrateperitem:this.openpickdeliveryrateperitem || null,
				openpickdeliverychargesminimum:this.openpickdeliverychargesminimum || null,
				openpickdeliveryapplicable:(this.openpickdeliveryapplicable=="Yes")?1:0,
				holidaydeliverycharges:this.holidaydeliverycharges || null,
				holidaydeliverymincharges: this.holidaydeliverymincharges || null,
				dccharges:this.dccharges || null,
				mechanicalhandlingcharges:this.mechanicalhandlingcharges || null,
				holidaydeliverychargeapplicable:(this.holidaydeliverychargeapplicable=="Yes")?1:0,
				deliveryattempttype:this.deliveryattempttype,
				demurragecostperdaytype:this.demurragecostperdaytype,
				delievryabovegroundlevelchargetype:this.delievryabovegroundlevelchargetype,
				holidaydeliverychargestype:this.holidaydeliverychargestype,
				vehicledeliveryratebasis:this.vehicledeliveryratebasis,
				vehicledeliveryslabtype:this.vehicledeliveryslabtype,
				vehicledeliveryslabchargetype:this.vehicledeliveryslabchargetype,

			}
			if(this.holidaydeliverychargeapplicable=="No"){
				submitobject.holidaydeliverychargestype = null
				submitobject.holidaydeliverycharges = null
				submitobject.holidaydeliverymincharges = null
			}
			if(this.rateType=="FLAT"){
				submitobject.mechanicalhandlingcharges=null;
			}
			if(this.vehicledeliveryapplicable=="No"){
				submitobject.vehicledeliverychargetype=null;
				submitobject.vehicledeliveryminimumchargeperdocket=null;
				submitobject.vehicledeliveryratebasis=null;
				submitobject.vehicledeliveryslabtype=null;
				submitobject.vehicledeliveryslabchargetype=null;
			}
			if(this.delievryabovegroundlevelapplicable=="No"){
				submitobject.delievryabovegroundlevelchargetype = null
				//submitobject.delievryabovegroundlevelcharge=null;
				submitobject.delievryabovegroundlevelmax=null;
			}
			if(this.demurragechargesapplicable=="No"){
				submitobject.demurragecostperdaytype=null;
				submitobject.demurragefreestoragedays=null;
				submitobject.demurragecostperday=null;
				submitobject.demurrageminimumcharges=null;
			}
			if(this.handlingchargesapplicable=="No"){
				submitobject.handlingchargephysicalwt=null;
				submitobject.handlingchargedimesnion.handlinglength=null;
				submitobject.handlingchargedimesnion.handlingbreadth=null;
				submitobject.handlingchargedimesnion.handlingHeight=null;
				submitobject.handlingchargeoverwtchargetype=null;
				submitobject.mechanicalhandlingcharges=null;

			}
			if(this.openpickdeliveryapplicable=="No"){
				submitobject.openpickdeliverychargesminimum=null;
				submitobject.openpickdeliverycharges=null;
				submitobject.openpickdeliveryrateperitem=null;
			}
			if(this.odachargesapplicable=="No"){
				submitobject.isodadeliverychargesidenticaltopickup=null;
				submitobject.odachargetype=null;
				submitobject.odacharges=null;
				submitobject.odachargesminimum=null;
				submitobject.odachargeslabchargetype=null;
				submitobject.odachargeslabtype=null;
				submitobject.odachargeratebasis=null;
			}
			if(this.pickupodachargesapplicable=="No"){
				submitobject.pickupodachargetype=null;
				submitobject.pickupodacharges=null;
				submitobject.pickupodachargesminimum=null;
				submitobject.pickupodachargeslabchargetype=null;
				submitobject.pickupodachargeslabtype=null;
				submitobject.pickupodachargeratebasis=null;
			}
			if(this.isodadeliverychargesidenticaltopickup=="Yes"){
				submitobject.odachargetype=submitobject.pickupodachargetype;
				submitobject.odacharges=submitobject.pickupodacharges;
				submitobject.odachargesminimum=submitobject.pickupodachargesminimum;
				submitobject.odachargeslabchargetype=submitobject.pickupodachargeslabchargetype;
				submitobject.odachargeslabtype=submitobject.pickupodachargeslabtype;
				submitobject.odachargeratebasis=submitobject.pickupodachargeratebasis;
			}
			if(this.odachargetype=="SlabRate"){
				submitobject.odacharges=0
			}
			if(this.pickupodachargetype=="SlabRate"){
				submitobject.pickupodacharges=0
			}
			if (this.rateTemplateId) {
			 await this.saveBothOdaTemplateData();
				if (this.oda1error == true) {
					this.$alert("Please enter ODA 1 charges", "", "error");
					return false;
				}
				this.saveVehicleDelivery();
				this.saveOverWtCharge();
				if(type == "saveAndNext"){
					submitobject.isTabChange = true;
					this.$emit("saveandnext", submitobject)
				} else {
					this.$emit("save", submitobject)
				}
				if (this.callFrom && (this.callFrom.name == CONSTANT.CONTRACT_TEMPLATE || this.callFrom.name == CONSTANT.CLIENT_CONTRACT_TEMPLATE)) {
					this.isSaved= true
				}

			} else {
				this.$emit("createAndGetId", submitobject);
			}

		},
		async setValuesAfterId(data) {
			try {
				if (data.id) {
					this.rateTemplateId = data.id;
					this.saveBothOdaTemplateData();
					this.saveVehicleDelivery();
					this.saveOverWtCharge();
					this.$emit("goToNextStepOrListing", 'list');
				}
			} catch (err) {
				this.isLoading = false;
				console.log(err)
			}
		},
		showChargePayType() {
			if (this.chargePayType == 'DOCKET') {
				this.showdocket = true
				this.showpercent = false
				this.fodCharges = this.payChargesInr
			} else {
				this.showdocket = false
				this.showpercent = true
				this.fodCharges = this.payChargePerc
			}
		},
		async getSlabList() {
			try {
				let weightInputPayload = {
				//	slabtype: CONSTANT.SLAB_TYPE.WEIGHT
				}
				let result = await Promise.all([MasterService.getAllSlab(weightInputPayload)]);
				this.allSlabDetails = result[0].data.data
				result[0].data.data.forEach(element => {
					let isdisabled = false;
					if(element.status==0){
					  isdisabled = true;
					}
					this.slablist.push({
						id: element.id,
						label: element.slabname,
						isDisabled:isdisabled
					});
				});
				let slabListGroup = this.groupBy(result[0].data.data, "slabtype")
				slabListGroup['1'].forEach(element => {
					let isdisabled = false;
					if(element.status==0){
					  isdisabled = true;
					}
					this.slablistforOWC.push({
						id: element.id,
						label: element.slabname,
						isDisabled:isdisabled
					});
				});
			} catch (err) {
				this.isLoading = false;
				console.log(err)
			}
		},
		selectslab(slab) {
			if (slab.id) {
				this.selectedslab = slab;
				this.slabid = slab.id;
				this.getSlabDetails(slab.id);
			}
		},
		selectshandlinglab(slab) {
			if (slab.id) {
				this.selectedhandlingslab = slab;
				this.handlingslabid = slab.id;
				this.gethandlingSlabDetails(slab.id);
			}
		},
		selectOdaSlab1(slab){
			if (slab.id) {
				this.selectedodaslab1 = slab;
				this.odaslabid1= slab.id;
				this.getOdaSlabDetails1(slab.id);
			}
		},
		selectOdaSlab2(slab){
			if (slab.id) {
				this.selectedodaslab2 = slab;
				this.odaslabid2= slab.id;
				this.getOdaSlabDetails2(slab.id);
			}
		},
		selectOdaSlab3(slab){
			if (slab.id) {
				this.selectedodaslab3 = slab;
				this.odaslabid3= slab.id;
				this.getOdaSlabDetails3(slab.id);
			}
		},
		selectOdaSlab4(slab){
			//special pin code charges
			if (slab.id) {
				this.selectedodaslab4 = slab;
				this.odaslabid4= slab.id;
				this.getOdaSlabDetails4(slab.id);
			}
		},
		pickupselectOdaSlab1(slab){
			if (slab.id) {
				this.pickupselectedodaslab1 = slab;
				this.pickupodaslabid1= slab.id;
				this.pickupgetOdaSlabDetails1(slab.id);
			}
		},
		pickupselectOdaSlab2(slab){
			if (slab.id) {
				this.pickupselectedodaslab2 = slab;
				this.pickupodaslabid2= slab.id;
				this.pickupgetOdaSlabDetails2(slab.id);
			}
		},
		pickupselectOdaSlab3(slab){
			if (slab.id) {
				this.pickupselectedodaslab3 = slab;
				this.pickupodaslabid3= slab.id;
				this.pickupgetOdaSlabDetails3(slab.id);
			}
		},
		pickupselectOdaSlab4(slab){
			//special pin code charges
			if (slab.id) {
				this.pickupselectedodaslab4 = slab;
				this.pickupodaslabid4= slab.id;
				this.pickupgetOdaSlabDetails4(slab.id);
			}
		},
		async getSlabDetails(id) {
			try {
				this.isAppointmentLoading = true;
				this.slabBreakupData = [];
				let inputPayload = {
					slabid: id
				}
				let response = await MasterService.getSlabDetails(inputPayload);
				response.data.data.slabbreakupdetails.forEach((el) => {
					let fromname = '';
					if (this.SYMBOL_CONFIG[el.lowerlimit] == '>') {
						fromname = el.lowerlimitvalue + 1;
					} else {
						fromname = el.lowerlimitvalue;
					}

					let toname = '';
					if (this.SYMBOL_CONFIG[el.higherlimit] == '<') {
						toname = el.higherlimitvalue - 1;
					} else {
						toname = el.higherlimitvalue;
					}
					this.slabBreakupData.push({
						slabsequence: el.slabnumber,
						fromname: fromname,
						toname: toname
					});
				});
				this.isAppointmentLoading = false;
			} catch (err) {
				this.isAppointmentLoading = false;
				this.isLoading = false;
				console.log(err)
			}
		},
		async gethandlingSlabDetails(id) {
			try {
				this.isHandlingLoading = true;

				let inputPayload = {
					slabid: id
				}
				let response = await MasterService.getSlabDetails(inputPayload);
				this.handlingslabBreakupData = [];
				this.handlingcostValue = [];
				response.data.data.slabbreakupdetails.forEach((el) => {
					let fromname = '';
					if (this.SYMBOL_CONFIG[el.lowerlimit] == '>') {
						fromname = el.lowerlimitvalue + 1;
					} else {
						fromname = el.lowerlimitvalue;
					}

					let toname = '';
					if (this.SYMBOL_CONFIG[el.higherlimit] == '<') {
						toname = el.higherlimitvalue - 1;
					} else {
						toname = el.higherlimitvalue;
					}
					this.handlingslabBreakupData.push({
						slabsequence: el.slabnumber,
						fromname: fromname,
						toname: toname,
					});
				});
				this.isHandlingLoading = false;
			} catch (err) {
				this.isHandlingLoading = false;
				this.isLoading = false;
				console.log(err)
			}
		},
		async getOdaSlabDetails1(id) {
			try {
				let inputPayload = {
					slabid: id
				}
				let response = await MasterService.getSlabDetails(inputPayload);
				this.odaslabbreakupdata1 = [];
				this.odacostvalue1 = [];
				this.odacostvalue12 = [];
				response.data.data.slabbreakupdetails.forEach((el) => {
					let name = `${this.SYMBOL_CONFIG[el.lowerlimit]} ${el.lowerlimitvalue} to
								${this.SYMBOL_CONFIG[el.higherlimit]} ${el.higherlimitvalue}`

					this.odaslabbreakupdata1.push({
						slabsequence: el.slabnumber,
						name: name,
						lowerlimit:el.lowerlimit,
						lowerlimitvalue:el.lowerlimitvalue,
						higherlimit:el.higherlimit,
						higherlimitvalue:el.higherlimitvalue,
					});
				});
			} catch (err) {
				this.isLoading = false;
				console.log(err)
			}
		},
		async getOdaSlabDetails2(id) {
			try {
				let inputPayload = {
					slabid: id
				}
				let response = await MasterService.getSlabDetails(inputPayload);
				this.odaslabbreakupdata2 = [];
				this.odacostvalue2 = [];
				this.odacostvalue22 = [];
				response.data.data.slabbreakupdetails.forEach((el) => {
					let name = `${this.SYMBOL_CONFIG[el.lowerlimit]} ${el.lowerlimitvalue} to
								${this.SYMBOL_CONFIG[el.higherlimit]} ${el.higherlimitvalue}`

					this.odaslabbreakupdata2.push({
						slabsequence: el.slabnumber,
						name: name,
						lowerlimit:el.lowerlimit,
						lowerlimitvalue:el.lowerlimitvalue,
						higherlimit:el.higherlimit,
						higherlimitvalue:el.higherlimitvalue,
					});
				});
			} catch (err) {
				this.isLoading = false;
				console.log(err)
			}
		},
		async getOdaSlabDetails3(id) {
			try {
				let inputPayload = {
					slabid: id
				}
				let response = await MasterService.getSlabDetails(inputPayload);
				this.odaslabbreakupdata3 = [];
				this.odacostvalue3 = [];
				response.data.data.slabbreakupdetails.forEach((el) => {
					let name = `${this.SYMBOL_CONFIG[el.lowerlimit]} ${el.lowerlimitvalue} to
								${this.SYMBOL_CONFIG[el.higherlimit]} ${el.higherlimitvalue}`

					this.odaslabbreakupdata3.push({
						slabsequence: el.slabnumber,
						name: name,
						lowerlimit:el.lowerlimit,
						lowerlimitvalue:el.lowerlimitvalue,
						higherlimit:el.higherlimit,
						higherlimitvalue:el.higherlimitvalue,
					});
				});
			} catch (err) {
				this.isLoading = false;
				console.log(err)
			}
		},
		async getOdaSlabDetails4(id) {
			//special pin code charge
			try {
				let inputPayload = {
					slabid: id
				}
				let response = await MasterService.getSlabDetails(inputPayload);
				this.odaslabbreakupdata4 = [];
				this.odacostvalue4 = [];
				this.odacostvalue42 = [];
				response.data.data.slabbreakupdetails.forEach((el) => {
					let name = `${this.SYMBOL_CONFIG[el.lowerlimit]} ${el.lowerlimitvalue} to
								${this.SYMBOL_CONFIG[el.higherlimit]} ${el.higherlimitvalue}`

					this.odaslabbreakupdata4.push({
						slabsequence: el.slabnumber,
						name: name,
						lowerlimit:el.lowerlimit,
						lowerlimitvalue:el.lowerlimitvalue,
						higherlimit:el.higherlimit,
						higherlimitvalue:el.higherlimitvalue,
					});
				});
			} catch (err) {
				this.isLoading = false;
				console.log(err)
			}
		},
		async pickupgetOdaSlabDetails1(id) {
			try {
				let inputPayload = {
					slabid: id
				}
				let response = await MasterService.getSlabDetails(inputPayload);
				this.pickupodaslabbreakupdata1 = [];
				this.pickupodacostvalue1 = [];
				this.pickupodacostvalue12 = [];
				response.data.data.slabbreakupdetails.forEach((el) => {
					let name = `${this.SYMBOL_CONFIG[el.lowerlimit]} ${el.lowerlimitvalue} to
								${this.SYMBOL_CONFIG[el.higherlimit]} ${el.higherlimitvalue}`

					this.pickupodaslabbreakupdata1.push({
						slabsequence: el.slabnumber,
						name: name,
						lowerlimit:el.lowerlimit,
						lowerlimitvalue:el.lowerlimitvalue,
						higherlimit:el.higherlimit,
						higherlimitvalue:el.higherlimitvalue,
					});
				});
			} catch (err) {
				this.isLoading = false;
				console.log(err)
			}
		},
		async pickupgetOdaSlabDetails2(id) {
			try {
				let inputPayload = {
					slabid: id
				}
				let response = await MasterService.getSlabDetails(inputPayload);
				this.pickupodaslabbreakupdata2 = [];
				this.pickupodacostvalue2 = [];
				this.pickupodacostvalue22 = [];
				response.data.data.slabbreakupdetails.forEach((el) => {
					let name = `${this.SYMBOL_CONFIG[el.lowerlimit]} ${el.lowerlimitvalue} to
								${this.SYMBOL_CONFIG[el.higherlimit]} ${el.higherlimitvalue}`

					this.pickupodaslabbreakupdata2.push({
						slabsequence: el.slabnumber,
						name: name,
						lowerlimit:el.lowerlimit,
						lowerlimitvalue:el.lowerlimitvalue,
						higherlimit:el.higherlimit,
						higherlimitvalue:el.higherlimitvalue,
					});
				});
			} catch (err) {
				this.isLoading = false;
				console.log(err)
			}
		},
		async pickupgetOdaSlabDetails3(id) {
			try {
				let inputPayload = {
					slabid: id
				}
				let response = await MasterService.getSlabDetails(inputPayload);
				this.pickupodaslabbreakupdata3 = [];
				this.pickupodacostvalue3 = [];
				response.data.data.slabbreakupdetails.forEach((el) => {
					let name = `${this.SYMBOL_CONFIG[el.lowerlimit]} ${el.lowerlimitvalue} to
								${this.SYMBOL_CONFIG[el.higherlimit]} ${el.higherlimitvalue}`

					this.pickupodaslabbreakupdata3.push({
						slabsequence: el.slabnumber,
						name: name,
						lowerlimit:el.lowerlimit,
						lowerlimitvalue:el.lowerlimitvalue,
						higherlimit:el.higherlimit,
						higherlimitvalue:el.higherlimitvalue,
					});
				});
			} catch (err) {
				this.isLoading = false;
				console.log(err)
			}
		},
		async pickupgetOdaSlabDetails4(id) {
			//special pin code charge
			try {
				let inputPayload = {
					slabid: id
				}
				let response = await MasterService.getSlabDetails(inputPayload);
				this.pickupodaslabbreakupdata4 = [];
				this.pickupodacostvalue4 = [];
				this.pickupodacostvalue42 = [];
				response.data.data.slabbreakupdetails.forEach((el) => {
					let name = `${this.SYMBOL_CONFIG[el.lowerlimit]} ${el.lowerlimitvalue} to
								${this.SYMBOL_CONFIG[el.higherlimit]} ${el.higherlimitvalue}`

					this.pickupodaslabbreakupdata4.push({
						slabsequence: el.slabnumber,
						name: name,
						lowerlimit:el.lowerlimit,
						lowerlimitvalue:el.lowerlimitvalue,
						higherlimit:el.higherlimit,
						higherlimitvalue:el.higherlimitvalue,
					});
				});
			} catch (err) {
				this.isLoading = false;
				console.log(err)
			}
		},
		setname(id, name) {
			return name + id;
		},
		async saveVehicleDelivery() {
			try {
				var inputPayload = {};
				inputPayload.ratetemplateid = this.rateTemplateId;
				inputPayload.vehicledeliveryapplicable = (this.vehicledeliveryapplicable=="Yes")?1:0;

				var vehicledelchargetype = null
				if(this.vehicledeliverychargetype=="FlatRate"){
					vehicledelchargetype = 1
				}else if(this.vehicledeliverychargetype=="SlabBased"){
					vehicledelchargetype = 2
				}else if(this.vehicledeliverychargetype=="ApprovalBasis"){
					vehicledelchargetype = 3
				}

				inputPayload.vehicledeliverychargetype = vehicledelchargetype;

				if (this.vehicledeliverychargetype=="SlabBased" && this.slabid != "" && this.slabid != null) {
					let slabbreakdetails = [];
					for (var i = 0; i < this.slabBreakupData.length; i++) {
						slabbreakdetails.push({
							slabid: this.slabid,
							slabsequence: this.slabBreakupData[i].slabsequence,
							fromvalue: this.slabBreakupData[i].fromname,
							tovalue: this.slabBreakupData[i].toname,
							cost: this.costValue[i],
						});
					}
					inputPayload.vehicledelivery = slabbreakdetails;
					inputPayload.lastmodifiedby = this.userName;
				}else{
					let slabbreakdetails = [];
						slabbreakdetails.push({
							cost: this.vehicledeliveryperkgcost,
						});
					inputPayload.vehicledelivery = slabbreakdetails;
					inputPayload.lastmodifiedby = this.userName;
				}
					this.isLoading = true;
					// let result = await MasterService.saveVehicleDelivery(inputPayload);
					let result;
					if (!this.callFrom) {
						result = await MasterService.saveVehicleDelivery(inputPayload);
					} else if (this.callFrom && this.callFrom.name == CONSTANT.CONTRACT_TEMPLATE) {
						inputPayload.ratetemplateid = this.callFrom.id
						inputPayload.contractid = this.callFrom.contractid
						inputPayload.contractservicesid = this.callFrom.contractservicesid
						result = await MasterService.saveContractMasterVehicleDeliveryRate(inputPayload)
					} else if (this.callFrom && this.callFrom.name == CONSTANT.CLIENT_CONTRACT_TEMPLATE) {
						inputPayload.ratetemplateid = this.callFrom.id
						inputPayload.contractid = this.callFrom.contractid
						inputPayload.contractservicesid = this.callFrom.contractservicesid
						result = await MasterService.saveClientContractMasterVehicleDeliveryRate(inputPayload)
					}
					this.isLoading = false;
					if (result.data.code == 200) {
						//this.$alert(result.data.message, this.slabName, "success");
						this.$emit("goBackToParent");
					} else {
						this.$alert(result.data.message, this.slabName, "error");
					}
			} catch (err) {
				this.isLoading = false;
				this.$alert(err, this.slabName, "error");
				console.log(err);
			}
		},
		async getLocationListDieselPrice(){
			var inputPayload = {};
			let tempArray = [];
			let result = await MasterService.getLocationListDieselPrice(inputPayload);
			if(result.data.code==200){
				let locationlist = result.data.data;
				locationlist.forEach(element => {
					tempArray.push({
						id: element.cityid,
						label: element.cityname
					});
				});
			}
			this.locationlistforDieselPrice = tempArray;
		},
		async getVehicleDeliveryDetails(isMasterRate) {
			try {
				var inputPayload = {};
				inputPayload.ratetemplateid = this.rateTemplateId;

				this.isAppointmentLoading = true;
				let response;
				// let response = await MasterService.getVehicleDeliveryDetails(inputPayload);
				if (!this.isSaved && (!this.callFrom || isMasterRate)) {
					response = await MasterService.getVehicleDeliveryDetails(inputPayload);
				} else if (this.callFrom && this.callFrom.name == CONSTANT.CONTRACT_TEMPLATE) {
					inputPayload.ratetemplateid = this.callFrom.id;
					response = await MasterService.getContractVehicleDeliveryRateList(inputPayload);
				} else if (this.callFrom && this.callFrom.name == CONSTANT.CLIENT_CONTRACT_TEMPLATE) {
					inputPayload.ratetemplateid = this.callFrom.id;
					response = await MasterService.getClientContractMasterVehicleDeliveryRateList(inputPayload);
				}
				this.slablistforVehicleDelivery = [];
				let slabListGroup = this.groupBy(this.allSlabDetails, "slabtype")
				if(this.vehicledeliveryslabtype == 1){
					slabListGroup['1'].forEach(element => {
						let isdisabled = false;
						if(element.status==0){
							isdisabled = true;
						}
						this.slablistforVehicleDelivery.push({
							id: element.id,
							label: element.slabname,
							isDisabled:isdisabled
						});
					});
				}if(this.vehicledeliveryslabtype == 2){
					slabListGroup['4'].forEach(element => {
						let isdisabled = false;
						if(element.status==0){
							isdisabled = true;
						}
						this.slablistforVehicleDelivery.push({
							id: element.id,
							label: element.slabname,
							isDisabled:isdisabled
						});
					});
				}
				this.isAppointmentLoading = false;
				if(this.vehicledeliverychargetype=="FlatRate"){
					let vehicleDeliveryData = response.data.data
					this.vehicledeliveryperkgcost=vehicleDeliveryData[0].cost
				}
				if(this.vehicledeliverychargetype=="SlabBased"){
				this.slabBreakupData = [];
				this.costValue = [];
				if (response.data.data.length > 0) {
					let vehicleDeliveryData = response.data.data;
					this.slabid = vehicleDeliveryData[0].slabid;
					this.selectedslab = this.getSlabObj(this.slabid);
					vehicleDeliveryData.forEach((item, index) => {
						this.slabBreakupData.push({
							slabsequence: item.slabsequence,
							fromname: item.fromvalue,
							toname: item.tovalue,
						});
						this.costValue[index] = item.cost;
					});
				}
			}
			} catch (err) {
				this.isAppointmentLoading = false;
				this.isLoading = false;
				console.log(err);
			}
		},
		async saveOverWtCharge() {
			try {
				var inputPayload = {};
				inputPayload.ratetemplateid = this.rateTemplateId;
				inputPayload.handlingchargesapplicable = (this.handlingchargesapplicable=="Yes")?1:0;

				let slabbreakdetails = [];
				if (this.rateType == 'FLAT') {
					slabbreakdetails.push({
						slabid: null,
						slabsequence: null,
						fromvalue: null,
						tovalue: null,
						cost: this.overweightcharges || null
					});
				} else {
					for (var i = 0; i < this.handlingslabBreakupData.length; i++) {
						slabbreakdetails.push({
							slabid: this.handlingslabid,
							slabsequence: this.handlingslabBreakupData[i].slabsequence,
							fromvalue: this.handlingslabBreakupData[i].fromname,
							tovalue: this.handlingslabBreakupData[i].toname,
							cost: this.handlingcostValue[i],
						});
					}
				}
				inputPayload.overweightcharge = slabbreakdetails;
				inputPayload.lastmodifiedby = this.userName;
				this.isLoading = true;
				// let result = await MasterService.saveOverWtCharge(inputPayload);
				let result;
				if (!this.callFrom) {
					result = await MasterService.saveOverWtCharge(inputPayload);
				} else if (this.callFrom && this.callFrom.name == CONSTANT.CONTRACT_TEMPLATE) {

					inputPayload.contractid = this.callFrom.contractid
					inputPayload.contractservicesid = this.callFrom.contractservicesid
					inputPayload.ratetemplateid = this.callFrom.id
					result = await MasterService.saveContractmasterOverWeightCharge(inputPayload);
				} else if (this.callFrom && this.callFrom.name == CONSTANT.CLIENT_CONTRACT_TEMPLATE) {

					inputPayload.contractid = this.callFrom.contractid
					inputPayload.contractservicesid = this.callFrom.contractservicesid
					inputPayload.ratetemplateid = this.callFrom.id
					result = await MasterService.saveClientContractMasterOverWeightCharge(inputPayload);
				}
				this.isLoading = false;
				if (result.data.code == 200) {
					// this.$alert(result.data.message, this.slabName, "success");
					this.$emit("goBackToParent");
				} else {
					this.$alert(result.data.message, this.slabName, "error");
				}
			} catch (err) {
				this.isLoading = false;
				this.$alert(err, this.slabName, "error");
				console.log(err);
			}
		},
		async getOverWtChargeDetails(isMasterRate) {
			try {
				var inputPayload = {};
				inputPayload.ratetemplateid = this.rateTemplateId;
				this.isHandlingLoading = true;
				// let response = await MasterService.getOverWtChargeDetails(inputPayload);
				let response;
				if (!this.isSaved && (!this.callFrom || isMasterRate)) {
					response = await MasterService.getOverWtChargeDetails(inputPayload);
				} else if (this.callFrom && this.callFrom.name == CONSTANT.CONTRACT_TEMPLATE) {
					inputPayload.ratetemplateid = this.callFrom.id
					response = await MasterService.getContractMasterOverWeightChargeList(inputPayload);

				} else if (this.callFrom && this.callFrom.name == CONSTANT.CLIENT_CONTRACT_TEMPLATE) {
					inputPayload.ratetemplateid = this.callFrom.id
					response = await MasterService.getClientContractMasterOverWeightChargeList(inputPayload);

				}
				this.handlingslabBreakupData = [];
				this.isHandlingLoading = false;
				if (response.data.data.length > 0) {
					let handlingChargesData = response.data.data;
					if (handlingChargesData[0].slabid == null) {
						this.rateType = 'FLAT';
						this.overweightcharges = handlingChargesData[0].cost;
					} else {
						this.rateType = 'SLAB';
						this.handlingslabid = handlingChargesData[0].slabid;
						this.selectedhandlingslab = this.getSlabObj(handlingChargesData[0].slabid);
						handlingChargesData.forEach((item, index) => {
							this.handlingslabBreakupData.push({
								slabsequence: item.slabsequence,
								fromname: item.fromvalue,
								toname: item.tovalue,
							});
							this.handlingcostValue[index] = item.cost;
						});
					}
				}
			} catch (err) {
				this.isHandlingLoading = false;
				this.isLoading = false;
				console.log(err);
			}
		},
		getSlabObj(slabid) {
			for (var i = 0; i < this.slablist.length; i++) {
				if (this.slablist[i].id == slabid) {
					return this.slablist[i];
				}
			}
		},
		showSlabWiseInput() {
			if (this.rateType == 'FLAT') {
				this.showflatoption = true
				this.showslaboption = false
			} else {
				this.showflatoption = false
				this.showslaboption = true
			}
		},
		checkflagIdenticalRate(){
			if(this.pickupodachargesapplicable=="No"){
				this.isodadeliverychargesidenticaltopickup="No";
			}
		},
		copypickupODACharges(){
			if(this.isodadeliverychargesidenticaltopickup=="Yes"){
				this.odachargeratebasis = this.pickupodachargeratebasis;
				this.odachargetype = this.pickupodachargetype;
				this.odachargeslabtype = this.pickupodachargeslabtype;
				this.odachargeslabchargetype = this.pickupodachargeslabchargetype;
				this.odachargesminimum = this.pickupodachargesminimum;
				this.odacostvalue1 = this.pickupodacostvalue1;
				this.odacostvalue12 = this.pickupodacostvalue12;
				this.odaslabid1 = this.pickupodaslabid1;
				this.odaslabbreakupdata1 = this.pickupodaslabbreakupdata1;
				this.odacostvalue2 = this.pickupodacostvalue2;
				this.odacostvalue22 = this.pickupodacostvalue22;
				this.odaslabid2 = this.pickupodaslabid2;
				this.odaslabbreakupdata2 = this.pickupodaslabbreakupdata2;
				this.odacostvalue3 = this.pickupodacostvalue3;
				this.odacostvalue32 = this.pickupodacostvalue32;
				this.odaslabid3 = this.pickupodaslabid3;
				this.odaslabbreakupdata3 = this.pickupodaslabbreakupdata3;
				this.odacostvalue4 = this.pickupodacostvalue4;
				this.odacostvalue42 = this.pickupodacostvalue42;
				this.odaslabid4 = this.pickupodaslabid4;
				this.odaslabbreakupdata4 = this.pickupodaslabbreakupdata4;
			}
		},
		resetOdaArray(){
			this.odaslabid1 =null;
			this.odaslabbreakupdata1 = [];
			this.odacostvalue1 = [];
			this.odacostvalue12 = [];
			this.selectedodaslab2 =null;
			this.odaslabid2 =null;
			this.odaslabbreakupdata2 = [];
			this.odacostvalue2 = [];
			this.odacostvalue22 = [];
			this.selectedodaslab3 =null;
			this.odaslabid3 =null;
			this.odaslabbreakupdata3 = [];
			this.odacostvalue3 = [];
			this.odacostvalue32 = [];
			this.selectedodaslab4 =null;
			this.odaslabid4 =null;
			this.odaslabbreakupdata4 = [];
			this.odacostvalue4 = []
			this.odacostvalue42 = []
		},
		pickupresetOdaArray(){
			this.pickupodaslabid1 =null;
			this.pickupodaslabbreakupdata1 = [];
			this.pickupodacostvalue1 = [];
			this.pickupodacostvalue12 = [];
			this.pickupselectedodaslab2 =null;
			this.pickupodaslabid2 =null;
			this.pickupodaslabbreakupdata2 = [];
			this.pickupodacostvalue2 = [];
			this.pickupodacostvalue22 = [];
			this.pickupselectedodaslab3 =null;
			this.pickupodaslabid3 =null;
			this.pickupodaslabbreakupdata3 = [];
			this.pickupodacostvalue3 = [];
			this.pickupodacostvalue32 = [];
			this.pickupselectedodaslab4 =null;
			this.pickupodaslabid4 =null;
			this.pickupodaslabbreakupdata4 = [];
			this.pickupodacostvalue4 = []
			this.pickupodacostvalue42 = []
		},
		selectOdaSlabDropdown(){
			this.odaslabid1 =null;
			this.odaslabbreakupdata1 = [];
			this.odacostvalue1 = [];
			this.odacostvalue12 = [];
			this.selectedodaslab2 =null;
			this.odaslabid2 =null;
			this.odaslabbreakupdata2 = [];
			this.odacostvalue2 = [];
			this.odacostvalue22 = [];
			this.selectedodaslab3 =null;
			this.odaslabid3 =null;
			this.odaslabbreakupdata3 = [];
			this.odacostvalue3 = [];
			this.odacostvalue32 = [];
			this.selectedodaslab4 =null;
			this.odaslabid4 =null;
			this.odaslabbreakupdata4 = [];
			this.odacostvalue4 = []
			this.odacostvalue42 = []
			this.slablistforODA = []
			let slabListGroup = this.groupBy(this.allSlabDetails, "slabtype")
			if(this.odachargeslabtype == 1){
				slabListGroup['1'].forEach(element => {
					let isdisabled = false;
					if(element.status==0){
					  isdisabled = true;
					}
					this.slablistforODA.push({
						id: element.id,
						label: element.slabname,
						isDisabled:isdisabled
					});
				});
			}if(this.odachargeslabtype == 2){
				slabListGroup['4'].forEach(element => {
					let isdisabled = false;
					if(element.status==0){
						isdisabled = true;
					}
					this.slablistforODA.push({
						id: element.id,
						label: element.slabname,
						isDisabled:isdisabled
					});
				});
			}
		},
		pickupselectOdaSlabDropdown(){
			this.pickupodaslabid1 =null;
			this.pickupodaslabbreakupdata1 = [];
			this.pickupodacostvalue1 = [];
			this.pickupodacostvalue12 = [];
			this.pickupselectedodaslab2 =null;
			this.pickupodaslabid2 =null;
			this.pickupodaslabbreakupdata2 = [];
			this.pickupodacostvalue2 = [];
			this.pickupodacostvalue22 = [];
			this.pickupselectedodaslab3 =null;
			this.pickupodaslabid3 =null;
			this.pickupodaslabbreakupdata3 = [];
			this.pickupodacostvalue3 = [];
			this.pickupodacostvalue32 = [];
			this.pickupselectedodaslab4 =null;
			this.pickupodaslabid4 =null;
			this.pickupodaslabbreakupdata4 = [];
			this.pickupodacostvalue4 = []
			this.pickupodacostvalue42 = []
			this.slablistforODA = []
			let slabListGroup = this.groupBy(this.allSlabDetails, "slabtype")
			if(this.pickupodachargeslabtype == 1){
				slabListGroup['1'].forEach(element => {
					let isdisabled = false;
					if(element.status==0){
					  isdisabled = true;
					}
					this.pickupslablistforODA.push({
						id: element.id,
						label: element.slabname,
						isDisabled:isdisabled
					});
				});
			}if(this.pickupodachargeslabtype == 2){
				slabListGroup['4'].forEach(element => {
					let isdisabled = false;
					if(element.status==0){
						isdisabled = true;
					}
					this.pickupslablistforODA.push({
						id: element.id,
						label: element.slabname,
						isDisabled:isdisabled
					});
				});
			}
		},
		selectVehicleDeliverySlab(){
			this.slabBreakupData = [];
			this.costValue = [];
			this.slablistforVehicleDelivery = [];
			this.slabid = null;
			let slabListGroup = this.groupBy(this.allSlabDetails, "slabtype")
			if(this.vehicledeliveryslabtype == 1){
				slabListGroup['1'].forEach(element => {
					let isdisabled = false;
					if(element.status==0){
						isdisabled = true;
					}
					this.slablistforVehicleDelivery.push({
						id: element.id,
						label: element.slabname,
						isDisabled:isdisabled
					});
				});
			}if(this.vehicledeliveryslabtype == 2){
				slabListGroup['4'].forEach(element => {
					let isdisabled = false;
					if(element.status==0){
						isdisabled = true;
					}
					this.slablistforVehicleDelivery.push({
						id: element.id,
						label: element.slabname,
						isDisabled:isdisabled
					});
				});
			}
		},

	}
}
Validator.extend('verifyToFodCharge', {
	getMessage: field => "MinFodCharge cannot be greater than MaxFodCharge.",
	validate: value => {
	  var minFodCharge = Number($("#minFodCharge").val());
	  var maxFodCharge = Number($("#maxFodCharge").val());
	   if (minFodCharge > maxFodCharge) {
		return false;
	  }else{
		return true;
	  }
	}
  });



// WEBPACK FOOTER //
// ./src/modules/masterdata/views/ratetemplate/createratetemplate/accessorialcharges/accessorialcharges.component.js